import React from "react";
import {
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaLocationArrow,
  FaMobileAlt,
  FaTelegram,
} from "react-icons/fa";
import Logo from "../../assets/logoCopy-removebg-preview.png";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div className="rounded-t-3xl bg-gradient-to-r from-[#001B38] to-[#09386b]">
      <section className="mx-auto max-w-[1200px] text-white">
        <div className=" grid py-5 md:grid-cols-3">
          <div className=" px-4 py-4 ">
            <h1 className="mb-3 text-justify text-xl font-bold sm:text-left sm:text-3xl">
              {/* <a href="/#home" className="">
                ጠበቃ
                <span className="inline-block font-bold text-primary">
                  አደራው
                </span>
              </a> */}
              <img className="w-40" src={Logo} />
            </h1>
            <p className="">
              Reliable legal and arbitration services grounded in integrity and
              community impact. We help organizations navigate complex legal
              challenges with clear, confident guidance.
            </p>
            <br />
            <div className="flex items-center gap-3">
              <FaLocationArrow />
              <p>Bahir Dar, Ethiopia</p>
            </div>
            <div className="mt-3 flex items-center gap-3">
              <FaMobileAlt />
              <p>+251 995 98 9898</p>
            </div>
            {/* Social Handle */}
          </div>
          <div className="col-span-2 grid grid-cols-2 sm:grid-cols-3 md:pl-10 ">
            <div className="">
              <div className="px-4 py-8 ">
                <h1 className="mb-3 text-justify text-xl font-bold sm:text-left sm:text-xl">
                  Important Links
                </h1>
                <ul className={`flex flex-col gap-3`}>
                  <li>
                    <Link
                      to="/"
                      className="cursor-pointer transition-all duration-300 hover:translate-x-[2px]"
                    >
                      Home
                    </Link>
                  </li>

                  <li>
                    <Link
                      to="/news-page"
                      className="cursor-pointer transition-all duration-300 hover:translate-x-[2px]"
                    >
                      News and Events
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/services"
                      className="cursor-pointer transition-all duration-300 hover:translate-x-[2px]"
                    >
                      Services
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/contact-page"
                      className="cursor-pointer transition-all duration-300 hover:translate-x-[2px]"
                    >
                      {" "}
                      Contact Us
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/about-us"
                      className="cursor-pointer transition-all duration-300 hover:translate-x-[2px]"
                    >
                      About us
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="">
              <div className="px-4 py-8 ">
                <h1 className="mb-3 text-justify text-xl font-bold sm:text-left sm:text-xl">
                  Practice Areas
                </h1>
                <ul className="flex flex-col gap-3">
                  <li>
                    <Link
                      to="/appointment"
                      className="cursor-pointer transition-all duration-300 hover:translate-x-[2px]"
                    >
                      {" "}
                      Schedule Consultation
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/#"
                      className="cursor-pointer transition-all duration-300 hover:translate-x-[2px]"
                    >
                      Arbitration
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/#"
                      className="cursor-pointer transition-all duration-300 hover:translate-x-[2px]"
                    >
                      {" "}
                      Law Counsel
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="">
              <div className="px-4 py-8 ">
                <h1 className="mb-3 text-justify text-xl font-bold sm:text-left sm:text-xl">
                  Social Links
                </h1>
                <div className="flex flex-col gap-3">
                  <h1>Subscribe to our newsletter</h1>
                  <input
                    className="rounded-full px-3 py-1 text-black focus:border-sky-500 focus:outline-none focus:ring-2 focus:ring-sky-500 "
                    type="text"
                    placeholder="Email"
                  />
                  <div className="mt-6 flex items-center gap-3">
                    <a
                      href="https://www.facebook.com/aderaw.addisu.5"
                      className="duration-200 hover:scale-105"
                    >
                      <FaFacebook className="text-3xl" />
                    </a>
                    <a
                      href="https://www.facebook.com/aderaw.addisu.5"
                      className="duration-200 hover:scale-105"
                    >
                      <FaInstagram className="text-3xl" />
                    </a>
                    <a
                      href="https://t.me/aderawaddisu"
                      className="duration-200 hover:scale-105"
                    >
                      <FaTelegram className="text-3xl" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="border-t-2 border-gray-300/50 py-6 text-center">
            ©2018 Aderaw Addisu || Lawyer & legal advisor
          </div>
        </div>
      </section>
    </div>
  );
};

export default Footer;
